__turbopack_context__.v({
  "comment-arrow": "CommentPaginator-module-scss-module__nZ-VPq__comment-arrow",
  "comment-current": "CommentPaginator-module-scss-module__nZ-VPq__comment-current",
  "comment-page": "CommentPaginator-module-scss-module__nZ-VPq__comment-page",
  "comment-paginator": "CommentPaginator-module-scss-module__nZ-VPq__comment-paginator",
  "comment-rating": "CommentPaginator-module-scss-module__nZ-VPq__comment-rating",
});
